import { HistoryModalTranslations } from "../models/history-modal-translaction-model";

export const ptBR: HistoryModalTranslations = {
  title: 'Histórico de Alterações',
  noData: 'Nenhum Histórico encontrado.',
  close: 'Fechar',
  headers: {
    timestamp: 'Data',
    revType: 'Tipo',
    userName: 'Executado Por',
    carrierName: 'Operadora',
    contractName: 'Contrato',
    patientName: 'Paciente',
    attributeName: 'Campo',
    oldValue: 'Valor Anterior',
    newValue: 'Valor Atual',
  }
};
